import { useState, useEffect } from 'react';
import { getExtensionPrice } from '../config/firebase';

export const useExtensionPrice = () => {
  const [price, setPrice] = useState<number>(1000);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const fetchedPrice = await getExtensionPrice();
        setPrice(fetchedPrice);
      } catch (error) {
        console.error('Erreur lors de la récupération du prix:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrice();
  }, []);

  return { price, loading };
}; 